import {OrderItem} from './OrderItem';
import {TotalCost} from './TotalCost';
import {SystemUser} from '../../shared/Models/SystemUser';
import {Supplier} from './Supplier';
import {OrderCustomRow} from './OrderCustomRow';
import {Option} from './Option';
import {CustomerDeliveryAddress} from './CustomerDeliveryAddress';
import {PosRegistration} from './PosRegistration';
import {DeliveryContact} from './DeliveryContact';
import {Discount} from './Discount';
import {ServiceContact} from '../../shared/Models/ServiceContact';
import {InvoiceDealer} from './InvoiceDealer';

export interface RealDealer {
  id: number;
  companyName?: string;
  fullName?: string;
  isCustomerAccount?: boolean;
  invoiceDealer?: InvoiceDealer;
}

export class Order {
  /**
   * Order Statuses
   */
  static NEW = {key: 'new', value: 'New'};
  static IN_PROCESS = {key: 'in_process', value: 'In process'};
  static DELIVERY = {key: 'delivery', value: 'Delivery'};
  static COMPLETED = {key: 'completed', value: 'Completed'};
  static ON_HOLD = {key: 'on_hold', value: 'On hold'};
  static FREE_DELIVERY_AMOUNT_NOT_REACHED = {key: 'free_delivery_amount_not_reached', value: 'Free delivery amount not reached'};
  static CANCELLED = {key: 'cancelled', value: 'Cancelled'};
  static CHANGED = {key: 'changed', value: 'Changed'};
  static SPLIT = {key: 'split', value: 'Split'};

  /**
   * Invoice statuses
   */
  static INVOICE_PAID = {key: 'paid', value: 'Paid'};
  static INVOICE_OPEN = {key: 'open', value: 'Open'};
  static INVOICE_OVERDUE = {key: 'overdue', value: 'Overdue'};
  static INVOICE_CREDITED = {key: 'credit_invoice', value: 'Credited'};
  static INVOICE_PARTIAL_PAID = {key: 'partial_paid', value: 'Partial paid'};

  /**
   * Partial order
   */
  static PARTIAL_ORDER_ALLOW = 'allowed';
  static PARTIAL_ORDER_NOT_ALLOW = 'not_allowed';

  /**
   * After how many days dealers can edit an order
   */
  static DAYS_ALLOWED_FOR_EDITING = 14;

  /**
   * Order export layouts
   */
  static layout_1 = 'layout1';
  static layout_2 = 'layout2';
  static layout_3 = 'layout3';
  static layout_4 = 'layout4';
  static layout_5 = 'layout5';
  /** Carpets: the rug supplier's layout. No layout 5 entry sits between them in the dropdown — FR-042 */
  static layout_6 = 'layout6';
  /** POS: the insurer's registration file. A .csv, not an xlsx like the other layouts — US-606 D6 */
  static layout_7 = 'layout7';
  static layout_delivery = 'layout_delivery';

  /**
   * order actions
   */
  static GENERATE_INVOICE_ACTION = 'generate_invoice';

  /**
   * order delivery at
   */
  static DELIVERY_AT_DEALER = 'dealer';
  static DELIVERY_AT_CUSTOMER = 'customer';
  static DEFAULT_DELIVERY_PRIMARY = 'primary';
  static DEFAULT_DELIVERY_SECONDARY = 'secondary';

  /**
   * Order Properties
   */
  public id: number;
  public orderNo?: string;
  public reference: string;
  public created: string;
  public orderItems: OrderItem[] = [];
  public orderItemOptions?: Option[] = [];
  public splitOrders: Order[] = [];
  public user: SystemUser | any;
  public status: string;
  public totalCost = new TotalCost();
  public allowDeliveryWeek = false;
  public deliveryWeek: string | boolean;
  public allowSecondaryDeliveryWeek = false;
  public secondaryDeliveryWeek: string | boolean;
  public secondaryDeliveryAt?: string;
  public expectedDeliveryWeek: string | boolean;
  public stockDeliveryWeek: string;
  public supplier: Supplier;
  public customRows: OrderCustomRow[];
  public allowPartial: string;
  public lastOrder?: Order;
  public isConverted?: boolean;
  public replyItem?: number;
  public isService?: boolean;
  public serviceRequestRemark?: any;
  public realDealer?: RealDealer;
  public transportationCost?: number;
  public deliveryCost?: number;
  public dealerDeliveryCost?: number;
  public remark?: string;
  public customerDeliveryAddress?: CustomerDeliveryAddress;
  /** POS insurance: the end customer's details, stored apart from the delivery address on purpose. */
  public posRegistration?: PosRegistration;
  public dealerDeliveryAddress?: DeliveryContact;
  public author: SystemUser | any;
  public remainingDays?: number;
  public discount?: Discount;
  public splitDiscountOn = undefined;
  public serviceContact?: ServiceContact;
  constructor() {
    this.customerDeliveryAddress = new CustomerDeliveryAddress();
    this.posRegistration = new PosRegistration();
    this.discount = new Discount();
  }
}
